'use client';

import FileUploadIconSvg from '@/assets/svgs/file-upload.svg';
import FileIconSvg from '@/assets/svgs/file.svg';
import { JobSuppressionListDetails } from '@/containers/Jobs/types';
import classNames from 'classnames';

import { inter500 } from '@/config/fonts';
import IconContainer from '@/shared/components/IconContainer/IconContainer';
import { pluralize } from '@/shared/utils/string';
import { ReactNode } from 'react';

interface SuppressionListItemViewProps {
  className?: string;
  data: JobSuppressionListDetails;
  actions?: ReactNode;
  shouldTruncateLengthyText?: boolean;
  style?: React.CSSProperties;
}

const SuppressionListItemView = ({
  className,
  data,
  actions,
  shouldTruncateLengthyText = true,
  style,
}: SuppressionListItemViewProps) => {
  const isProcessing = data.suppression_list_state === 'PENDING';

  return (
    <div
      className={classNames('flex items-center justify-between gap-3', className)}
      style={style}>
      <div className="flex gap-3">
        <IconContainer
          icon={
            isProcessing ? (
              <FileUploadIconSvg className="h-5 w-5" />
            ) : (
              <FileIconSvg className="h-5 w-5" />
            )
          }
          className={classNames({
            'bg-transparent opacity-50': isProcessing,
          })}
        />
        <div
          className={classNames('flex flex-col gap-0.5 text-left', {
            tooltip: data.suppression_list_name.length > 47 && shouldTruncateLengthyText,
          })}
          data-tip={data.suppression_list_name}>
          <span
            className={classNames('text-sm', inter500.className, {
              'text-gray-default w-[350px] overflow-hidden text-ellipsis whitespace-nowrap':
                shouldTruncateLengthyText,
              'opacity-50': isProcessing,
            })}>
            {data.suppression_list_name}
          </span>
          {isProcessing ? (
            <span className="text-gray-default text-[13px] opacity-50">
              Processing...
            </span>
          ) : (
            <span className="text-gray-default text-[13px]">
              <span>
                {data.leads_loaded} {pluralize('contact', data.leads_loaded)}
              </span>
            </span>
          )}
        </div>
      </div>
      <div className="actions shrink-0 self-center">
        {isProcessing ? (
          <div className="tooltip flex w-20 py-5" data-tip="Processing...">
            <progress
              className="progress progress-primary h-1 w-16"
              value={50}
              max="100"
            />
          </div>
        ) : (
          actions
        )}
      </div>
    </div>
  );
};

export default SuppressionListItemView;
